import { css } from 'styled-components';
import { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XSM } from '../constants';

export const screens = {
  mobile375: BREAKPOINT_XSM,
  mobile: BREAKPOINT_SM,
  tablet: BREAKPOINT_MD,
  desktop: BREAKPOINT_LG,
};

export const query = Object.keys(screens).reduce((acc, label) => {
  acc[label] = `(max-width: ${screens[label]}px)`;
  return acc;
}, {});

const mq = Object.keys(screens).reduce((acc, label) => {
  acc[label] = styles =>
    css`
      @media ${query[label]} {
        ${styles};
      }
    `;

  return acc;
}, {});

export default mq;



// WEBPACK FOOTER //
// ./src/utils/media-queries.js